const products = [
  {
    name: 'ALFA VPN',
    tagline: 'Secure. Private. Fast.',
    description:
      'A high-performance VPN application for iOS that encrypts your internet connection, masks your IP address, and keeps your online activity completely private — wherever you are.',
    highlights: ['Military-grade AES-256 encryption', 'Zero-log policy', 'Global server network', 'One-tap connect'],
    icon: 'ri-shield-keyhole-line',
    color: 'from-emerald-500 to-teal-600',
    lightColor: 'bg-emerald-50',
    accentColor: 'text-emerald-600',
    image: 'https://public.readdy.ai/ai/img_res/f67ff916d90236a085c6da078583360b.jpg',
  },
  {
    name: 'ALFA Cleaner',
    tagline: 'Clean. Fast. Optimized.',
    description:
      'An intelligent iOS cleaner that removes junk files, frees up storage space, and optimizes your device performance — keeping your iPhone running like new every single day.',
    highlights: ['Smart junk detection', 'Duplicate photo finder', 'Memory optimizer', 'Battery health monitor'],
    icon: 'ri-speed-up-line',
    color: 'from-slate-700 to-slate-900',
    lightColor: 'bg-slate-50',
    accentColor: 'text-slate-700',
    image: 'https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20app%20interface%20on%20iPhone%20mockup%2C%20clean%20minimal%20UI%20with%20speedometer%20and%20optimization%20icons%2C%20dark%20slate%20and%20charcoal%20color%20scheme%2C%20floating%20on%20white%20background%2C%20professional%20product%20photography%20style&width=480&height=600&seq=cleaner-product-alfa&orientation=portrait',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-600 mb-3 block">What We Build</span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">Our Products</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
            Purpose-built iOS applications that put security and performance in your hands.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {products.map((product) => (
            <div
              key={product.name}
              className="group rounded-3xl overflow-hidden border border-gray-100 hover:-translate-y-2 transition-transform duration-300 bg-white"
            >
              {/* Image area */}
              <div className={`relative h-72 bg-gradient-to-br ${product.color} flex items-end justify-center overflow-hidden`}>
                <div className="absolute inset-0 opacity-20">
                  <div className="absolute top-6 right-6 w-32 h-32 rounded-full border-2 border-white/30" />
                  <div className="absolute bottom-10 left-8 w-20 h-20 rounded-full border border-white/20" />
                </div>
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-64 w-auto object-contain object-bottom relative z-10 translate-y-4 group-hover:translate-y-2 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${product.color}`}>
                    <i className={`${product.icon} text-white text-lg`} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{product.name}</h3>
                    <span className={`text-xs font-semibold tracking-widest uppercase ${product.accentColor}`}>{product.tagline}</span>
                  </div>
                </div>

                <p className="text-gray-500 text-sm leading-relaxed mb-6">{product.description}</p>

                <ul className="grid grid-cols-2 gap-2">
                  {product.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-sm text-gray-600">
                      <span className={`w-1.5 h-1.5 rounded-full bg-gradient-to-br ${product.color} flex-shrink-0`} />
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
